import { render } from "./SubmissionManagement.html?vue&type=template&id=38612072&scoped=true"
import script from "./SubmissionManagement.js?vue&type=script&lang=js"
export * from "./SubmissionManagement.js?vue&type=script&lang=js"

import "./SubmissionManagement.css?vue&type=style&index=0&id=38612072&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38612072"]])

export default __exports__